import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { postData } from '../../../../Services/Fetchnodeservices';

// Icons as SVG components
const CalendarIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>);
const TagIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>);
const PercentIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M19 5L5 19M9 6.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0zM20 17.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0z"/></svg>);
const GiftIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>);
const SwapIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M17 2l4 4-4 4"/><path d="M3 12h15.5M7 22l-4-4 4-4"/><path d="M21 12H5.5"/><path d="M17 12v8"/></svg>);
const PlusIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>);
const CheckIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>);
const ChevronDownIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polyline points="6 9 12 15 18 9"/></svg>);
const ClockIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>);
const EditIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>);
const TrashIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>);
const EyeIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>);
const BackIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>);
const SparklesIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 3L14 8L19 10L14 12L12 17L10 12L5 10L10 8L12 3Z"/><path d="M19 4L20 7L23 8L20 9L19 12L18 9L15 8L18 7L19 4Z"/></svg>);
const TrendingIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M23 6l-9.5 9.5-5-5L1 18"/><path d="M17 6h6v6"/></svg>);
const MoonIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>);
const SunIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>);

const AddOffer = ({ isDark = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const [designation_id, setDesignationId] = useState(null);
  const [restaurantName, setRestaurantName] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const [selectedOfferType, setSelectedOfferType] = useState('fixed');
  const [discountAmount, setDiscountAmount] = useState('');
  const [discountPercent, setDiscountPercent] = useState('');
  const [buyQuantity, setBuyQuantity] = useState('');
  const [getQuantity, setGetQuantity] = useState('');
  const [selectedFreeProduct, setSelectedFreeProduct] = useState(null);
  const [showFreeProductDropdown, setShowFreeProductDropdown] = useState(false);
  const [validFrom, setValidFrom] = useState('');
  const [validTo, setValidTo] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [productList, setProductList] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [activeTab, setActiveTab] = useState('create');
  
  const offersSectionRef = useRef(null);

  const offerTypes = [
    { id: 'fixed', title: 'Fixed Discount', description: 'Flat amount off', icon: <TagIcon />, color: '#3B82F6', bgColor: '#EFF6FF', darkBgColor: '#1E3A5F', apiType: 'discount' },
    { id: 'percentage', title: 'Percentage Off', description: '% off total', icon: <PercentIcon />, color: '#10B981', bgColor: '#ECFDF5', darkBgColor: '#1B4D3E', apiType: 'percentage' },
    { id: 'buyNGetN', title: 'Buy N Get N', description: 'Same product free', icon: <GiftIcon />, color: '#F59E0B', bgColor: '#FFFBEB', darkBgColor: '#5C3D1A', apiType: 'buy_get' },
    { id: 'buyNGetX', title: 'Buy N Get X', description: 'Different product', icon: <SwapIcon />, color: '#8B5CF6', bgColor: '#F5F3FF', darkBgColor: '#3B2E5F', apiType: 'buy_get_x' }
  ];

  // Theme-aware styles
  const getThemeStyles = () => ({
    bgPrimary: isDark ? '#111827' : '#F9FAFB',
    bgSecondary: isDark ? '#1F2937' : '#FFFFFF',
    bgTertiary: isDark ? '#374151' : '#F3F4F6',
    textPrimary: isDark ? '#F9FAFB' : '#111827',
    textSecondary: isDark ? '#9CA3AF' : '#6B7280',
    textMuted: isDark ? '#6B7280' : '#9CA3AF',
    border: isDark ? '#374151' : '#E5E7EB',
    borderLight: isDark ? '#4B5563' : '#F3F4F6',
    cardBg: isDark ? '#1F2937' : '#FFFFFF',
    inputBg: isDark ? '#374151' : '#F9FAFB',
    hoverBg: isDark ? '#374151' : '#F9FAFB',
  });

  const styles = getThemeStyles();

  // Fetch products/menu from API
  const fetchProducts = async () => {
    if (!designation_id) return;
    
    setLoadingProducts(true);
    try {
      const response = await postData("offers/menu", { designation_id: designation_id });
      let productsData = [];
      
      if (response && response.status === true && response.data) {
        response.data.forEach((menuItem) => {
          if (menuItem.items) {
            let itemsJson = menuItem.items;
            if (typeof itemsJson === 'string') {
              try {
                const parsedItems = JSON.parse(itemsJson);
                if (Array.isArray(parsedItems)) {
                  productsData = [...productsData, ...parsedItems];
                }
              } catch (parseError) {
                console.error("Error parsing items JSON:", parseError);
              }
            } else if (Array.isArray(itemsJson)) {
              productsData = [...productsData, ...itemsJson];
            }
          }
        });
      }
      
      setProductList(productsData);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoadingProducts(false);
    }
  };

  // Fetch offers from API
  const fetchOffers = async () => {
    if (!designation_id) return;
    
    setLoading(true);
    try {
      const response = await postData("offers/offer", { designation_id: designation_id });
      let offersData = [];
      if (response && response.status === true && response.data) {
        offersData = response.data;
      }
      setOffers(offersData);
    } catch (error) {
      console.error("Error fetching offers:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Get designation_id from navigation state
  useEffect(() => {
    if (location.state && location.state.designation_id) {
      setDesignationId(location.state.designation_id);
      setRestaurantName(location.state.restaurantName || '');
    } else {
      const storedRestaurant = sessionStorage.getItem('selectedRestaurant');
      if (storedRestaurant) {
        const restaurant = JSON.parse(storedRestaurant);
        setDesignationId(restaurant.designation_id);
        setRestaurantName(restaurant.restaurantName || '');
      }
    }
  }, [location]);

  // Fetch data when designation_id is available
  useEffect(() => {
    if (designation_id) {
      fetchProducts();
      fetchOffers();
    }
  }, [designation_id]);

  const isValid = () => {
    if (!selectedProduct) { alert('Please select a product'); return false; }
    if (selectedOfferType === 'fixed' && (!discountAmount || parseFloat(discountAmount) <= 0)) { alert('Please enter a valid discount amount'); return false; }
    if (selectedOfferType === 'percentage' && (!discountPercent || parseFloat(discountPercent) <= 0 || parseFloat(discountPercent) > 100)) { alert('Please enter a valid percentage (1-100)'); return false; }
    if ((selectedOfferType === 'buyNGetN' || selectedOfferType === 'buyNGetX') && (!buyQuantity || parseInt(buyQuantity) <= 0)) { alert('Please enter valid buy quantity'); return false; }
    if (selectedOfferType === 'buyNGetN' && (!getQuantity || parseInt(getQuantity) <= 0)) { alert('Please enter valid get quantity'); return false; }
    if (selectedOfferType === 'buyNGetX' && !selectedFreeProduct) { alert('Please select the free product'); return false; }
    if (validFrom && validTo && new Date(validFrom) > new Date(validTo)) { alert('End date must be after start date'); return false; }
    return true;
  };

  const handleCreateOffer = async () => {
    if (!isValid() || !designation_id) return;
    
    setIsSubmitting(true);
    const offerTypeMap = { fixed: 'discount', percentage: 'percentage', buyNGetN: 'buy_get', buyNGetX: 'buy_get_x' };
    
    let offerData = {
      designation_id: designation_id,
      product_id: selectedProduct.product_id,
      offer_name: selectedProduct.name,
      offer_type: offerTypeMap[selectedOfferType],
      status: '1',
    };

    if (selectedOfferType === 'fixed') offerData.offer = discountAmount;
    else if (selectedOfferType === 'percentage') offerData.offer = discountPercent;
    else if (selectedOfferType === 'buyNGetN') { offerData.buy_quantity = buyQuantity; offerData.free_quantity = getQuantity; offerData.offer = '0'; }
    else if (selectedOfferType === 'buyNGetX') { offerData.buy_quantity = buyQuantity; offerData.item_free = selectedFreeProduct.product_id; offerData.offer = '0'; }
    
    if (validFrom) offerData.offer_start = validFrom;
    if (validTo) offerData.offer_end = validTo;

    try {
      const response = await postData("/offers/create_offer", offerData);
      if (response && response.status === true) {
        alert('Offer created successfully!');
        resetForm();
        fetchOffers();
        setActiveTab('manage');
      } else {
        alert(response?.message || 'Failed to create offer');
      }
    } catch (error) {
      alert('Failed to create offer: ' + error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteOffer = async (offerId) => {
    if (!window.confirm('Are you sure you want to delete this offer?')) return;
    try {
      const response = await postData("/offers/delete_offer", { id: offerId });
      if (response && response.status === true) {
        alert('Offer deleted successfully!');
        fetchOffers();
      }
    } catch (error) {
      alert('Failed to delete offer');
    }
  };

  const handleEditOffer = (offer) => {
    const product = productList.find(p => p.product_id == offer.product_id);
    if (product) setSelectedProduct(product);
    
    if (offer.offer_type === 'discount') { setSelectedOfferType('fixed'); setDiscountAmount(offer.offer); }
    else if (offer.offer_type === 'percentage') { setSelectedOfferType('percentage'); setDiscountPercent(offer.offer); }
    else if (offer.offer_type === 'buy_get') { setSelectedOfferType('buyNGetN'); setBuyQuantity(offer.buy_quantity || ''); setGetQuantity(offer.free_quantity || ''); }
    else if (offer.offer_type === 'buy_get_x') { setSelectedOfferType('buyNGetX'); setBuyQuantity(offer.buy_quantity || ''); }
    
    if (offer.offer_start) setValidFrom(offer.offer_start.split(' ')[0]);
    if (offer.offer_end) setValidTo(offer.offer_end.split(' ')[0]);
    setActiveTab('create');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const resetForm = () => {
    setSelectedProduct(null);
    setSelectedOfferType('fixed');
    setDiscountAmount('');
    setDiscountPercent('');
    setBuyQuantity('');
    setGetQuantity('');
    setSelectedFreeProduct(null);
    setValidFrom('');
    setValidTo('');
  };

  const getOfferTypeText = (type) => {
    const types = { 'discount': 'Fixed', 'percentage': 'Percentage', 'buy_get': 'Buy N Get N', 'buy_get_x': 'Buy N Get X' };
    return types[type] || type;
  };

  const getOfferDescription = (offer) => {
    if (offer.offer_type === 'discount') return `₦${offer.offer} off`;
    if (offer.offer_type === 'percentage') return `${offer.offer}% off`;
    if (offer.offer_type === 'buy_get') return `Buy ${offer.buy_quantity}, Get ${offer.free_quantity} free`;
    if (offer.offer_type === 'buy_get_x') return `Buy ${offer.buy_quantity}, Get free product`;
    return offer.offer_name;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const handleBack = () => navigate(-1);

  const getActiveOfferCount = () => {
    return offers.filter(offer => offer.status === '1').length;
  };

  if (!designation_id) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: styles.bgPrimary }}>
        <div style={{ textAlign: 'center', background: styles.cardBg, padding: '40px', borderRadius: '24px', boxShadow: '0 20px 40px rgba(0,0,0,0.1)' }}>
          <div style={{ width: '48px', height: '48px', border: `3px solid ${styles.border}`, borderTopColor: '#6366F1', borderRadius: '50%', margin: '0 auto 16px auto', animation: 'spin 1s linear infinite' }} />
          <p style={{ color: styles.textSecondary, fontSize: '14px' }}>Loading restaurant information...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: styles.bgPrimary, fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", transition: 'all 0.3s ease' }}>
      <div style={{ position: 'relative', zIndex: 1, padding: '32px 24px' }}>
        {/* Header */}
        <div style={{ maxWidth: '1200px', margin: '0 auto 32px auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
            <button 
              onClick={handleBack} 
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                padding: '10px 20px',
                background: styles.bgTertiary,
                border: `1px solid ${styles.border}`,
                borderRadius: '40px',
                color: styles.textPrimary,
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.3s ease'
              }}
            >
              <BackIcon /> Back to Dashboard
            </button>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', background: styles.bgTertiary, padding: '8px 20px', borderRadius: '40px', border: `1px solid ${styles.border}` }}>
                <SparklesIcon />
                <span style={{ color: styles.textPrimary, fontSize: '14px', fontWeight: '500' }}>{restaurantName}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* Stats Cards */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '32px' }}>
            <div style={{ background: styles.cardBg, borderRadius: '20px', padding: '20px', border: `1px solid ${styles.border}` }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <p style={{ fontSize: '12px', color: styles.textSecondary, marginBottom: '8px' }}>Total Products</p>
                  <p style={{ fontSize: '28px', fontWeight: '700', color: styles.textPrimary }}>{productList.length}</p>
                </div>
                <div style={{ width: '40px', height: '40px', background: styles.bgTertiary, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: styles.textSecondary }}>
                  <TagIcon />
                </div>
              </div>
            </div>
            <div style={{ background: styles.cardBg, borderRadius: '20px', padding: '20px', border: `1px solid ${styles.border}` }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <p style={{ fontSize: '12px', color: styles.textSecondary, marginBottom: '8px' }}>Active Offers</p>
                  <p style={{ fontSize: '28px', fontWeight: '700', color: styles.textPrimary }}>{getActiveOfferCount()}</p>
                </div>
                <div style={{ width: '40px', height: '40px', background: styles.bgTertiary, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: styles.textSecondary }}>
                  <TrendingIcon />
                </div>
              </div>
            </div>
            <div style={{ background: styles.cardBg, borderRadius: '20px', padding: '20px', border: `1px solid ${styles.border}` }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <p style={{ fontSize: '12px', color: styles.textSecondary, marginBottom: '8px' }}>Total Offers</p>
                  <p style={{ fontSize: '28px', fontWeight: '700', color: styles.textPrimary }}>{offers.length}</p>
                </div>
                <div style={{ width: '40px', height: '40px', background: styles.bgTertiary, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: styles.textSecondary }}>
                  <GiftIcon />
                </div>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div style={{ display: 'flex', gap: '12px', marginBottom: '24px', background: styles.bgTertiary, borderRadius: '60px', padding: '6px', width: 'fit-content' }}>
            <button
              onClick={() => setActiveTab('create')}
              style={{
                padding: '12px 28px',
                borderRadius: '40px',
                border: 'none',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                background: activeTab === 'create' ? styles.bgSecondary : 'transparent',
                color: activeTab === 'create' ? '#667eea' : styles.textSecondary
              }}
            >
              ✨ Create Offer
            </button>
            <button
              onClick={() => setActiveTab('manage')}
              style={{
                padding: '12px 28px',
                borderRadius: '40px',
                border: 'none',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                background: activeTab === 'manage' ? styles.bgSecondary : 'transparent',
                color: activeTab === 'manage' ? '#667eea' : styles.textSecondary
              }}
            >
              📋 Manage Offers
            </button>
          </div>

          {/* Create Offer Form */}
          {activeTab === 'create' && (
            <div style={{ background: styles.cardBg, borderRadius: '32px', overflow: 'hidden', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)', border: `1px solid ${styles.border}` }}>
              <div style={{ padding: '32px', borderBottom: `1px solid ${styles.border}`, background: isDark ? '#1F2937' : 'linear-gradient(135deg, #F8FAFF 0%, #FFFFFF 100%)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ width: '48px', height: '48px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <SparklesIcon style={{ color: 'white' }} />
                  </div>
                  <div>
                    <h2 style={{ fontSize: '28px', fontWeight: '700', color: styles.textPrimary, margin: 0 }}>Create New Offer</h2>
                    <p style={{ fontSize: '14px', color: styles.textSecondary, marginTop: '4px' }}>Design attractive promotions to boost your sales</p>
                  </div>
                </div>
              </div>

              <div style={{ padding: '32px' }}>
                {/* Product Selection */}
                <div style={{ marginBottom: '32px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Select Product</label>
                  <div style={{ position: 'relative' }}>
                    <button 
                      onClick={() => setShowProductDropdown(!showProductDropdown)} 
                      disabled={loadingProducts} 
                      style={{ 
                        width: '100%', 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center', 
                        padding: '14px 20px', 
                        border: `2px solid ${styles.border}`, 
                        borderRadius: '16px', 
                        backgroundColor: styles.inputBg,
                        cursor: 'pointer', 
                        fontSize: '14px',
                        transition: 'all 0.2s ease',
                        color: styles.textPrimary
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.borderColor = '#667eea'}
                      onMouseLeave={(e) => e.currentTarget.style.borderColor = styles.border}
                    >
                      <span style={selectedProduct ? { color: styles.textPrimary, fontWeight: '500' } : { color: styles.textMuted }}>
                        {loadingProducts ? 'Loading products...' : (selectedProduct ? selectedProduct.name : 'Choose a product')}
                      </span>
                      <ChevronDownIcon />
                    </button>
                    
                    {showProductDropdown && !loadingProducts && (
                      <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, marginTop: '8px', border: `1px solid ${styles.border}`, borderRadius: '16px', backgroundColor: styles.cardBg, zIndex: 10, maxHeight: '300px', overflow: 'auto', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)' }}>
                        {productList.length === 0 ? (
                          <div style={{ padding: '20px', textAlign: 'center', color: styles.textMuted }}>No products found</div>
                        ) : (
                          productList.map((product) => (
                            <div 
                              key={product.product_id} 
                              onClick={() => { setSelectedProduct(product); setShowProductDropdown(false); }} 
                              style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center', 
                                padding: '12px 20px', 
                                cursor: 'pointer', 
                                borderBottom: `1px solid ${styles.borderLight}`,
                                transition: 'background 0.2s ease'
                              }}
                              onMouseEnter={(e) => e.currentTarget.style.background = styles.hoverBg}
                              onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                            >
                              <div>
                                <span style={{ fontSize: '14px', fontWeight: '500', color: styles.textPrimary }}>{product.name}</span>
                                {product.price && <span style={{ fontSize: '13px', color: '#10B981', marginLeft: '12px', fontWeight: '600' }}>₦{product.price}</span>}
                                {product.category && <div style={{ fontSize: '11px', color: styles.textMuted, marginTop: '2px' }}>{product.category}</div>}
                              </div>
                              {selectedProduct?.product_id === product.product_id && <CheckIcon style={{ color: '#10B981' }} />}
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Offer Type Selection */}
                <div style={{ marginBottom: '32px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '12px' }}>Offer Type</label>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                    {offerTypes.map((type) => (
                      <button
                        key={type.id}
                        onClick={() => setSelectedOfferType(type.id)}
                        style={{
                          padding: '20px',
                          borderRadius: '20px',
                          border: `2px solid ${selectedOfferType === type.id ? type.color : styles.border}`,
                          background: selectedOfferType === type.id ? (isDark ? type.darkBgColor : type.bgColor) : styles.cardBg,
                          cursor: 'pointer',
                          textAlign: 'center',
                          transition: 'all 0.3s ease',
                          transform: selectedOfferType === type.id ? 'scale(1.02)' : 'scale(1)'
                        }}
                      >
                        <div style={{
                          width: '56px',
                          height: '56px',
                          borderRadius: '28px',
                          background: selectedOfferType === type.id ? `${type.color}20` : styles.bgTertiary,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 12px auto',
                          color: selectedOfferType === type.id ? type.color : styles.textSecondary
                        }}>
                          {type.icon}
                        </div>
                        <span style={{ fontSize: '15px', fontWeight: '600', color: selectedOfferType === type.id ? type.color : styles.textPrimary, marginBottom: '4px', display: 'block' }}>{type.title}</span>
                        <span style={{ fontSize: '12px', color: styles.textSecondary }}>{type.description}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Dynamic Fields */}
                {(selectedOfferType === 'fixed' || selectedOfferType === 'percentage') && (
                  <div style={{ marginBottom: '32px' }}>
                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>
                      {selectedOfferType === 'fixed' ? 'Discount Amount (₦)' : 'Discount Percentage (%)'}
                    </label>
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      border: `2px solid ${styles.border}`, 
                      borderRadius: '16px', 
                      padding: '0 20px', 
                      backgroundColor: styles.inputBg,
                      transition: 'all 0.2s ease'
                    }}>
                      {selectedOfferType === 'fixed' ? 
                        <span style={{ fontSize: '20px', fontWeight: '600', color: '#667eea', marginRight: '12px' }}>₦</span> : 
                        <div style={{ marginRight: '12px', color: '#667eea' }}><PercentIcon /></div>
                      }
                      <input 
                        type="number" 
                        style={{ 
                          flex: 1, 
                          padding: '14px 0', 
                          fontSize: '16px', 
                          fontWeight: '500',
                          border: 'none', 
                          outline: 'none', 
                          backgroundColor: 'transparent',
                          color: styles.textPrimary
                        }} 
                        placeholder={selectedOfferType === 'fixed' ? 'e.g., 500' : 'e.g., 20'} 
                        value={selectedOfferType === 'fixed' ? discountAmount : discountPercent} 
                        onChange={(e) => selectedOfferType === 'fixed' ? setDiscountAmount(e.target.value) : setDiscountPercent(e.target.value)} 
                      />
                      {selectedOfferType === 'percentage' && <span style={{ fontSize: '16px', fontWeight: '500', color: styles.textSecondary, marginLeft: '8px' }}>%</span>}
                    </div>
                  </div>
                )}

                {(selectedOfferType === 'buyNGetN' || selectedOfferType === 'buyNGetX') && (
                  <>
                    <div style={{ marginBottom: '24px' }}>
                      <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Buy Quantity</label>
                      <div style={{ display: 'flex', alignItems: 'center', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '0 20px', backgroundColor: styles.inputBg }}>
                        <GiftIcon style={{ color: '#667eea' }} />
                        <input 
                          type="number" 
                          style={{ flex: 1, padding: '14px 0', fontSize: '16px', border: 'none', outline: 'none', backgroundColor: 'transparent', marginLeft: '12px', color: styles.textPrimary }} 
                          placeholder="e.g., 2" 
                          value={buyQuantity} 
                          onChange={(e) => setBuyQuantity(e.target.value)} 
                        />
                      </div>
                    </div>
                    {selectedOfferType === 'buyNGetN' && (
                      <div style={{ marginBottom: '24px' }}>
                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Get Quantity (Free)</label>
                        <div style={{ display: 'flex', alignItems: 'center', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '0 20px', backgroundColor: styles.inputBg }}>
                          <GiftIcon style={{ color: '#10B981' }} />
                          <input 
                            type="number" 
                            style={{ flex: 1, padding: '14px 0', fontSize: '16px', border: 'none', outline: 'none', backgroundColor: 'transparent', marginLeft: '12px', color: styles.textPrimary }} 
                            placeholder="e.g., 1" 
                            value={getQuantity} 
                            onChange={(e) => setGetQuantity(e.target.value)} 
                          />
                        </div>
                      </div>
                    )}
                    {selectedOfferType === 'buyNGetX' && (
                      <div style={{ marginBottom: '24px' }}>
                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Free Product</label>
                        <div style={{ position: 'relative' }}>
                          <button 
                            onClick={() => setShowFreeProductDropdown(!showFreeProductDropdown)} 
                            style={{ 
                              width: '100%', 
                              display: 'flex', 
                              justifyContent: 'space-between', 
                              alignItems: 'center', 
                              padding: '14px 20px', 
                              border: `2px solid ${styles.border}`, 
                              borderRadius: '16px', 
                              backgroundColor: styles.inputBg, 
                              cursor: 'pointer', 
                              fontSize: '14px',
                              color: styles.textPrimary
                            }}
                          >
                            <span style={selectedFreeProduct ? { color: styles.textPrimary, fontWeight: '500' } : { color: styles.textMuted }}>
                              {selectedFreeProduct ? selectedFreeProduct.name : 'Select free product'}
                            </span>
                            <ChevronDownIcon />
                          </button>
                          {showFreeProductDropdown && (
                            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, marginTop: '8px', border: `1px solid ${styles.border}`, borderRadius: '16px', backgroundColor: styles.cardBg, zIndex: 10, maxHeight: '250px', overflow: 'auto', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)' }}>
                              {productList.filter(p => p.product_id !== selectedProduct?.product_id).map((product) => (
                                <div 
                                  key={product.product_id} 
                                  onClick={() => { setSelectedFreeProduct(product); setShowFreeProductDropdown(false); }} 
                                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 20px', cursor: 'pointer', borderBottom: `1px solid ${styles.borderLight}` }}
                                >
                                  <span style={{ fontSize: '14px', color: styles.textPrimary }}>{product.name}</span>
                                  {selectedFreeProduct?.product_id === product.product_id && <CheckIcon style={{ color: '#10B981' }} />}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}

                {/* Validity */}
                <div style={{ marginBottom: '32px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Validity Period (Optional)</label>
                  <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '12px', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '10px 20px', backgroundColor: styles.inputBg }}>
                      <CalendarIcon style={{ color: '#667eea' }} />
                      <input 
                        type="date" 
                        style={{ flex: 1, border: 'none', outline: 'none', backgroundColor: 'transparent', fontSize: '14px', color: styles.textPrimary }} 
                        value={validFrom} 
                        onChange={(e) => setValidFrom(e.target.value)} 
                      />
                      <span style={{ fontSize: '12px', color: styles.textMuted }}>Start</span>
                    </div>
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '12px', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '10px 20px', backgroundColor: styles.inputBg }}>
                      <ClockIcon style={{ color: '#667eea' }} />
                      <input 
                        type="date" 
                        style={{ flex: 1, border: 'none', outline: 'none', backgroundColor: 'transparent', fontSize: '14px', color: styles.textPrimary }} 
                        value={validTo} 
                        onChange={(e) => setValidTo(e.target.value)} 
                      />
                      <span style={{ fontSize: '12px', color: styles.textMuted }}>End</span>
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <button 
                  onClick={handleCreateOffer} 
                  disabled={isSubmitting} 
                  style={{ 
                    width: '100%', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    gap: '12px', 
                    padding: '16px',
                    background: isSubmitting ? (isDark ? '#4B5563' : '#9CA3AF') : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    border: 'none', 
                    borderRadius: '20px', 
                    color: '#FFFFFF', 
                    fontSize: '16px', 
                    fontWeight: '600', 
                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                  }}
                  onMouseEnter={(e) => !isSubmitting && (e.currentTarget.style.transform = 'translateY(-2px)')}
                  onMouseLeave={(e) => !isSubmitting && (e.currentTarget.style.transform = 'translateY(0)')}
                >
                  <PlusIcon />
                  <span>{isSubmitting ? 'Creating Offer...' : 'Create Offer'}</span>
                </button>
              </div>
            </div>
          )}

          {/* Manage Offers Table */}
          {activeTab === 'manage' && (
            <div ref={offersSectionRef} style={{ background: styles.cardBg, borderRadius: '32px', overflow: 'hidden', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)', border: `1px solid ${styles.border}` }}>
              <div style={{ padding: '24px 32px', borderBottom: `1px solid ${styles.border}`, background: isDark ? '#1F2937' : 'linear-gradient(135deg, #F8FAFF 0%, #FFFFFF 100%)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
                <div>
                  <h3 style={{ fontSize: '20px', fontWeight: '700', color: styles.textPrimary, margin: 0 }}>All Offers</h3>
                  <p style={{ fontSize: '14px', color: styles.textSecondary, marginTop: '4px' }}>Manage and monitor your existing promotions</p>
                </div>
                <button 
                  onClick={fetchOffers} 
                  style={{ 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    gap: '8px', 
                    padding: '10px 20px', 
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                    border: 'none', 
                    borderRadius: '12px', 
                    color: 'white', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    cursor: 'pointer',
                    transition: 'transform 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-1px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <EyeIcon /> Refresh ({offers.length})
                </button>
              </div>

              {loading ? (
                <div style={{ textAlign: 'center', padding: '60px', color: styles.textSecondary }}>
                  <div style={{ width: '48px', height: '48px', border: `3px solid ${styles.border}`, borderTopColor: '#667eea', borderRadius: '50%', margin: '0 auto 16px auto', animation: 'spin 1s linear infinite' }} />
                  <p>Loading offers...</p>
                </div>
              ) : error ? (
                <div style={{ textAlign: 'center', padding: '60px', color: '#EF4444' }}>
                  <p>Error loading offers: {error}</p>
                  <button onClick={fetchOffers} style={{ marginTop: '16px', padding: '10px 24px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', border: 'none', borderRadius: '12px', color: '#fff', cursor: 'pointer' }}>Try Again</button>
                </div>
              ) : offers.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '80px 40px', color: styles.textMuted }}>
                  <div style={{ width: '80px', height: '80px', background: styles.bgTertiary, borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px auto' }}>
                    <TagIcon style={{ width: '40px', height: '40px', opacity: 0.5 }} />
                  </div>
                  <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px', color: styles.textPrimary }}>No offers yet</p>
                  <p style={{ fontSize: '13px' }}>Create your first offer to start attracting more customers</p>
                  <button 
                    onClick={() => setActiveTab('create')} 
                    style={{ marginTop: '20px', padding: '10px 24px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', border: 'none', borderRadius: '12px', color: 'white', cursor: 'pointer' }}
                  >
                    Create Offer
                  </button>
                </div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: styles.bgTertiary, borderBottom: `1px solid ${styles.border}` }}>
                        <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>#</th>
                        <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Offer Name</th>
                        <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Type</th>
                        <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Details</th>
                        <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Validity</th>
                        <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Status</th>
                        <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {offers.map((offer, index) => (
                        <tr key={offer.id} style={{ borderBottom: `1px solid ${styles.borderLight}`, transition: 'background 0.2s ease' }}>
                          <td style={{ padding: '16px 20px', fontSize: '14px', fontWeight: '500', color: styles.textPrimary }}>{index + 1}</td>
                          <td style={{ padding: '16px 20px', fontSize: '14px', fontWeight: '600', color: styles.textPrimary }}>{offer.offer_name}</td>
                          <td style={{ padding: '16px 20px' }}>
                            <span style={{ 
                              display: 'inline-block', 
                              padding: '4px 12px', 
                              borderRadius: '20px', 
                              fontSize: '11px', 
                              fontWeight: '600',
                              background: offer.offer_type === 'discount' ? (isDark ? '#1E3A5F' : '#EFF6FF') : 
                                        offer.offer_type === 'percentage' ? (isDark ? '#1B4D3E' : '#ECFDF5') :
                                        offer.offer_type === 'buy_get' ? (isDark ? '#5C3D1A' : '#FFFBEB') : (isDark ? '#3B2E5F' : '#F5F3FF'),
                              color: offer.offer_type === 'discount' ? '#3B82F6' : 
                                     offer.offer_type === 'percentage' ? '#10B981' :
                                     offer.offer_type === 'buy_get' ? '#F59E0B' : '#8B5CF6'
                            }}>
                              {getOfferTypeText(offer.offer_type)}
                            </span>
                          </td>
                          <td style={{ padding: '16px 20px', fontSize: '13px', color: styles.textSecondary }}>{getOfferDescription(offer)}</td>
                          <td style={{ padding: '16px 20px', fontSize: '12px', color: styles.textSecondary }}>
                            {formatDate(offer.offer_start)} → {formatDate(offer.offer_end)}
                          </td>
                          <td style={{ padding: '16px 20px', textAlign: 'center' }}>
                            <span style={{ 
                              display: 'inline-flex', 
                              alignItems: 'center',
                              gap: '6px',
                              padding: '4px 12px', 
                              borderRadius: '20px', 
                              fontSize: '11px', 
                              fontWeight: '600', 
                              background: offer.status === '1' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(148, 163, 184, 0.1)', 
                              color: offer.status === '1' ? '#10B981' : '#94A3B8' 
                            }}>
                              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: offer.status === '1' ? '#10B981' : '#94A3B8' }}></span>
                              {offer.status === '1' ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td style={{ padding: '16px 20px', textAlign: 'center' }}>
                            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                              <button 
                                onClick={() => handleEditOffer(offer)} 
                                style={{ 
                                  padding: '8px', 
                                  background: 'transparent', 
                                  border: 'none', 
                                  cursor: 'pointer', 
                                  color: '#F59E0B', 
                                  borderRadius: '8px',
                                  transition: 'background 0.2s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.background = isDark ? '#5C3D1A' : '#FFFBEB'}
                                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                title="Edit Offer"
                              >
                                <EditIcon />
                              </button>
                              <button 
                                onClick={() => handleDeleteOffer(offer.id)} 
                                style={{ 
                                  padding: '8px', 
                                  background: 'transparent', 
                                  border: 'none', 
                                  cursor: 'pointer', 
                                  color: '#EF4444', 
                                  borderRadius: '8px',
                                  transition: 'background 0.2s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.background = isDark ? '#7F1D1D' : '#FEF2F2'}
                                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                title="Delete Offer"
                              >
                                <TrashIcon />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddOffer;